export default {
  maxRow: 4,
  maxColumn: 4,
  range: 10,
  desc: `{{value}}年`,
  generator(start) {
    let results = [[]],
      maxRow = this.maxRow,
      maxColumn = this.maxColumn,
      desc = this.desc,
      range = this.range;

    for (let row = 0; row < maxRow; row++) {
      let temp = [], value;

      for (let col = 0; col < maxColumn; col++) {
        value = start + row * maxColumn + col;

        if (row * maxColumn + col >= range) {
          break;
        }

        temp.push({
          value,
          row: row,
          column: col,
          inRange: false,
          start: false,
          end: false,
          page: 1,
          text: desc.replace(/{{value}}/, value),
          disabled: false,
          selected: false
        });
      }

      results[0].push(temp);
    }

    return results;
  },

  enableBtn(start, end) {
    const range = this.range;

    return end - range > start;
  },

  enablePageBtn() {
    return false;
  },

  leftDate(year) {
    return year;
  },

  rightDate(start, end) {
    const range = this.range;

    const isInSameZone = Math.floor(start / range) === Math.floor(end / range);

    return isInSameZone ? start + this.range : end;
  },

  displayFormatter(date) {
    try {
      if (!date) {
        return "";
      }
      
      date = new Date("" + date);
      const year = date.getFullYear();

      return `${year}`;
    } catch (err) {
      throw new Error(err);
    }
  },

  displayLabelFormatter(year) {
    const range = this.range;
    const start = Math.floor(year / range) * range;
    const end = start + (range - 1);

    return `${start}-${end}年`;
  },

  valueFormatter(date, isStart) {
    try {
      const { column, row, year } = date;

      return `${year + row * this.maxColumn + column}-${isStart ? "01-01" : "12-31"}`;
    } catch (err) {
      throw new Error(err);
    }
  },

  change(isPrev) {
    return (isPrev ? -1 : 1) * this.range;
  },

  dateToPos(date) {
    if (!(date instanceof Date)) {
      date = new Date("" + date);
    }

    const currYear = date.getFullYear();

    const range = this.range;
    const start = Math.floor(currYear / range) * range;

    const rest = currYear % range;
    let row = Math.floor(rest / this.maxColumn);
    let column = rest % this.maxColumn;

    return {
      column,
      row,
      value: currYear,
      year: start,
      page: 1
    };
  }
};
